<div class="trinka_cloud_wrap">
    <div id="particles-js"></div>

    <section class="mainTopBanner">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="topBannerWrapper">
                        <div class="top-banner-left">
                            <h1>LaTeXファイル自動校正</h1>
                            <h2>LaTeXファイルの<br/>
                                英文校正も数分で</h2>
                                <p>LaTeXファイルの自動校正機能で作業を効率化。プラグインのインストールの必要もありません。校正後のLaTeXファイルと同時に生成されるWordファイルで、変更履歴もご確認いただけます。</p>
                            <div class="btn-group">
                                <a href="https://cloud.trinka.ai/signup?_rg=JP" class="filled-btn" target="_blank">今すぐ始める</a>
                            </div>
                        </div>
                        <div class="top-banner-right">
                            <img src="assets/images/Latex-banner.jpg" alt="LaTeX ファイルの文法エラーを校正する - 文法 チェック" class="img-fluid">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>


    <div class="howItWorks section-pd list-wrapper-style-2">
        <div class="trinka_container">
            <div class="row align-items-center">
                <div class="col-lg-6">
                    <div class="list-wrapper-image">
                        <a href="" data-toggle="modal" data-target="#wordPluginPopup" id="VewiVideoSection">
                            <img src="assets/images/yt-thumbnail/latexThumbnail.webp" alt="ラテックスサムネイル - 英文校正" class="img-fluid eposter-img">
                        </a>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="list-wrapper-content-2">
                        <div class="trinka-title mb-0">
                            <h2>LaTeXファイル
                                自動校正の使い方</h2>
                            <div class="HeadingSubLine1"><span></span><span></span><span></span></div>
                            <p>TrinkaのLaTeXファイル自動校正機能の使い方を、簡単なウォークスルービデオでご覧いただけます。 </p>
                            <p>ステップごとの解説で、機能を余すところなくお使いいただけます。</p>
                            <p><a style="color: #0000ff;" (click)="scroll(target)" class="text-link">FAQ</a>もあわせてお読みください。</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="cloud_key_features section-pd list-wrapper-style-2">
        <div class="trinka_container">
            <div class="row justify-content-center">
                <div class="col-md-11 col-lg-10">
                    <div class="trinka-title mb-0 text-center">
                        <h2>TrinkaのLaTeXファイル自動校正の主な機能</h2>
                        <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                        <p>LaTeXファイル校正においてTrinkaが優れている点</p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-4 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards bt-none">
                        <img src="assets/images/DownloadTrackChangesEdit.svg" alt="変更履歴の表示 - 英文校正 ">
                        <h3>変更履歴の表示</h3>
                        <p>校正済みのLaTeX ファイルとともに、変更履歴付きのMS Word ファイルも生成します。</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards">
                        <img src="assets/images/RetainOriginalFormatting.png" alt="フォーマット・レイアウトの保持 - 英文校正 ">
                        <h3>フォーマット・レイアウトの保持</h3>
                        <p>元原稿のフォーマットやレイアウトは変わらず、テキストのみを校正。ソースコードやタグは変更されません。</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards">
                        <img src="assets/images/languageScore_icon.svg" alt="言語スコアの提供 - 英文チ ェッカー">
                        <h3>言語スコアの提供</h3>
                        <p>文法カテゴリごとの修正数に基づき、文書全体の言語の品質をスコア表示します。</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards bt-1">
                        <img src="assets/images/TableofRevisions_icon.svg" alt="修正項目一覧 - 文法 チェック ">
                        <h3>修正項目一覧</h3>
                        <p>カテゴリー別の修正項目が一覧表示され、どのような校正が行われたかをご確認いただけます。</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards bt-1">
                        <img src="assets/images/style_guide_icon.svg" alt="スタイルガイドの設定 - 英文 チェック ">
                        <h3>スタイルガイドの設定</h3>
                        <p>一般的な学術論文のスタイルガイド（APA、AMA、AGU、ACS、IEEE）に準拠して、原稿の文法や語彙を修正できます。</p>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="list-wrapper-content-2 list-style-cards bt-1">
                        <img src="assets/images/subjectAreaAndDocumentType.svg" alt="修正提案の種類を選択 - 英文校正">
                        <h3>修正提案の種類を選択</h3>
                        <p>Trinkaによる修正提案の種類はご選択可能。文脈に沿った最適な提案を行います。</p>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div class="importFiles section-pd-sm">
        <div class="trinka_container">
            <div class="row align-items-center">
                <div class="col-lg-5">
                    <div class="trinka-title mb-0">
                        <h3>お使いのストレージからファイルをインポートして、
                            わずか数分で校正完了！</h3>
                    </div>
                </div>
                <div class="col-lg-7">
                    <ul>
                        <li>
                            <div class="uploadFileIcon">
                                <svg width="50" height="46" viewBox="0 0 26 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M21.6349 15.109C21.6349 15.3108 21.5751 15.5081 21.4629 15.676C21.3508 15.8438 21.1914 15.9746 21.0049 16.0518C20.8184 16.1291 20.6132 16.1493 20.4152 16.1099C20.2173 16.0705 20.0354 15.9733 19.8927 15.8306C19.7499 15.6879 19.6527 15.506 19.6134 15.3081C19.574 15.1101 19.5942 14.9049 19.6714 14.7184C19.7487 14.5319 19.8795 14.3725 20.0473 14.2604C20.2152 14.1482 20.4125 14.0884 20.6143 14.0884C20.885 14.0884 21.1446 14.1959 21.336 14.3873C21.5274 14.5787 21.6349 14.8383 21.6349 15.109V15.109Z" fill="#773795"/>
                                    <path d="M24.9945 10.7444C24.9945 10.5326 25.3093 11.3578 21.1944 1.46144C21.1374 1.32431 21.0409 1.20723 20.9172 1.12507C20.7934 1.04291 20.6481 0.999383 20.4996 1.00001H6.24404C6.10455 0.999291 5.96763 1.03753 5.8487 1.11042C5.72977 1.18332 5.63356 1.28796 5.57089 1.41258C0.685141 11.1841 1.02171 10.4729 1 10.6412C1 10.7118 1 10.1961 1 18.2413C1 18.3397 1.01938 18.4371 1.05703 18.528C1.09467 18.6188 1.14986 18.7014 1.21942 18.771C1.28899 18.8406 1.37157 18.8957 1.46246 18.9334C1.55335 18.971 1.65077 18.9904 1.74915 18.9904H24.2453C24.4421 18.9904 24.631 18.913 24.7712 18.7748C24.9114 18.6367 24.9916 18.4489 24.9945 18.2521C24.9945 18.1273 24.9945 10.7986 24.9945 10.7444V10.7444ZM24.9945 10.6901H1.02171H24.9945Z" stroke="#4f4f4f" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </div>
                            <p>Trinka My Drive</p>
                        </li>
                        <li>
                            <div class="uploadFileIcon">
                                <svg width="52" height="46" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4.25 0C3.65326 0 3.08097 0.237053 2.65901 0.65901C2.23705 1.08097 2 1.65326 2 2.25V11.25C2 11.8467 2.23705 12.419 2.65901 12.841C3.08097 13.2629 3.65326 13.5 4.25 13.5H19.75C20.3467 13.5 20.919 13.2629 21.341 12.841C21.7629 12.419 22 11.8467 22 11.25V2.25C22 1.65326 21.7629 1.08097 21.341 0.65901C20.919 0.237053 20.3467 0 19.75 0H4.25ZM3.5 2.25C3.5 2.05109 3.57902 1.86032 3.71967 1.71967C3.86032 1.57902 4.05109 1.5 4.25 1.5H19.75C19.9489 1.5 20.1397 1.57902 20.2803 1.71967C20.421 1.86032 20.5 2.05109 20.5 2.25V11.25C20.5 11.4489 20.421 11.6397 20.2803 11.7803C20.1397 11.921 19.9489 12 19.75 12H4.25C4.05109 12 3.86032 11.921 3.71967 11.7803C3.57902 11.6397 3.5 11.4489 3.5 11.25V2.25ZM0.75 14.5C0.551088 14.5 0.360322 14.579 0.21967 14.7197C0.0790175 14.8603 0 15.0511 0 15.25C0 15.4489 0.0790175 15.6397 0.21967 15.7803C0.360322 15.921 0.551088 16 0.75 16H23.25C23.4489 16 23.6397 15.921 23.7803 15.7803C23.921 15.6397 24 15.4489 24 15.25C24 15.0511 23.921 14.8603 23.7803 14.7197C23.6397 14.579 23.4489 14.5 23.25 14.5H0.75Z" fill="#4f4f4f"/>
                                    <path d="M10 6H14" stroke="#773795" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </div>
                            <p>ローカルフォルダ</p>
                        </li>
                        <li>
                            <div class="uploadFileIcon">
                                <svg width="51" height="47" viewBox="0 0 24 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g clip-path="url(#clip0_1393_8871)">
                                    <path d="M5.99953 0L0 3.82228L5.99953 7.64466L12 3.82228L5.99953 0ZM18 0L12 3.82266L18 7.64531L24.0001 3.82266L18 0ZM0 11.4676L5.99953 15.29L12 11.4676L5.99953 7.64531L0 11.4676ZM18 7.64531L12 11.468L18 15.2905L24 11.468L18 7.64531ZM6 16.5723L12.0005 20.3947L18 16.5723L12.0005 12.75L6 16.5723Z" fill="#0061FF"/>
                                    </g>
                                    <defs>
                                    <clipPath id="clip0_1393_8871">
                                    <rect width="24" height="20.4375" fill="white"/>
                                    </clipPath>
                                    </defs>
                                </svg>
                            </div>
                            <p >DropBox</p>
                        </li>
                        <li>
                            <div class="uploadFileIcon">
                                <svg width="50" height="46" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1.81444 18.3783L2.87287 20.2064C3.09281 20.5914 3.40894 20.8938 3.78009 21.1137C4.84322 19.7643 5.58309 18.7287 6.00009 18.0071C6.42319 17.2749 6.94322 16.1293 7.56019 14.5707C5.89744 14.3518 4.63744 14.2424 3.78019 14.2424C2.95734 14.2424 1.69734 14.3518 0 14.5707C0 14.9968 0.109969 15.4229 0.329906 15.8079L1.81444 18.3783V18.3783Z" fill="#0066DA"/>
                                    <path d="M20.2204 21.1137C20.5917 20.8938 20.9078 20.5914 21.1276 20.2065L21.5675 19.4505L23.6707 15.8079C23.8866 15.4313 24.0003 15.0048 24.0005 14.5707C22.2933 14.3518 21.0357 14.2424 20.2274 14.2424C19.3587 14.2424 18.1009 14.3518 16.4541 14.5707C17.0638 16.1379 17.5769 17.2834 17.9937 18.0071C18.4139 18.7374 19.1562 19.7728 20.2204 21.1137V21.1137Z" fill="#EA4335"/>
                                    <path d="M11.9998 6.87291C13.2298 5.38744 14.0775 4.24191 14.5428 3.4365C14.9175 2.78794 15.3299 1.75238 15.7799 0.329906C15.4088 0.109969 14.9827 0 14.5428 0H9.45685C9.01698 0 8.59098 0.12375 8.21973 0.329906C8.79216 1.96134 9.27798 3.12244 9.67698 3.81309C10.118 4.57641 10.8923 5.59631 11.9998 6.87291Z" fill="#00832D"/>
                                    <path d="M16.4401 14.5706H7.56028L3.78027 21.1136C4.15134 21.3335 4.57743 21.4435 5.01731 21.4435H18.9831C19.4229 21.4435 19.8491 21.3197 20.2202 21.1135L16.4402 14.5706H16.4401Z" fill="#2684FC"/>
                                    <path d="M12.0001 6.87298L8.22009 0.330078C7.84884 0.550016 7.53272 0.852359 7.31278 1.2373L0.329906 13.3336C0.114012 13.7102 0.000285232 14.1366 0 14.5707H7.56019L12.0002 6.87298H12.0001Z" fill="#00AC47"/>
                                    <path d="M20.1788 7.28524L16.6872 1.23705C16.4674 0.852115 16.1512 0.549772 15.78 0.329834L12 6.87284L16.4398 14.5706H23.9863C23.9863 14.1444 23.8763 13.7184 23.6564 13.3334L20.1788 7.28524Z" fill="#FFBA00"/>
                                </svg>
                            </div>
                            <p >Googleドライブ</p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <div class="sampleReport section-pd">
        <div class="trinka_container">
            <div class="row justify-content-center">
                <div class="col-md-10 col-lg-8">
                    <div class="trinka-title mb-0 text-center">
                        <h2>LaTeX自動校正ファイルのサンプル</h2>
                        <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    </div>
                </div>
                <div class="col-sm-12">
                    <div class="viewSampleReportImg">
                        <img src="assets/images/latex-sample-report.svg" class="img-fluid" alt="ラテックス文法チェッカーのサンプルレポート">
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div class="trinka-banner section-pd-sm">
        <div class="trinka_container">
            <div class="row justify-content-center">
                <div class="col-md-10 col-lg-8">
                    <div class="trinka-title text-center">
                        <h3 class="text-white">LaTeXファイルの言語品質を
                            たちどころに改善</h3>
                    </div>
                    <div class="btn-group justify-content-center">
                        <a href="https://cloud.trinka.ai/signup?_rg=JP" class="white-btn" target="_blank">今すぐ始める</a>
                    </div>
                </div>
            </div>  
        </div>
    </div>

    <div class="trinka-credits section-pd pb-0">
        <div class="trinka_container">
            <div class="row justify-content-center">
                <div class="col-md-11 col-lg-10">
                    <div class="trinka-title mb-0 text-center">
                        <h2>LaTeXファイル校正機能はTrinkaトークンでお使いいただけます</h2>
                        <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    </div>
                </div>
                <div class="col-md-12 col-lg-10">
                    <div class="credit-section">
                        <div class="shape">
                            <svg xmlns="http://www.w3.org/2000/svg" width="745" height="140" viewBox="0 0 745 140" fill="none">
                                <path d="M210.74 99.3391C92.7255 118.025 21.074 68.6063 0 41.5614V169H721.602C749.822 122.013 775.522 23.2037 652.567 3.86251C498.872 -20.314 358.258 75.9822 210.74 99.3391Z" fill="#F5ECFF"/>
                            </svg>
                        </div>
                        <div class="media">
                            <div class="media-left">
                                <img src="assets/images/new-credits.svg" alt="クレジット - 英文校正 " />
                            </div>
                            <div class="media-body">
                                <h6>5000単語ごとに1Trinkaトークンが必要です。ご利用プランのアカウントに無料で付与されるポイントに加え、ポイントの追加購入も可能です。</h6>
                            </div>
                        </div>
                        <div class="image">
                            <img src="assets/images/credits-banner.svg" alt="クレジット - 文法 チェック" />
                        </div>
                    </div>
                    <ul>
                        <li><span>*</span>
                            <p>
                                ポイントは、Trinkaの各種機能にご利用いただけます。<br/>
                                毎月、プレミアムプランとプレミアムプラスプランのユーザーには10ポイント、ベーシックプランのユーザーには4ポイントが無料で付与されます。詳しくは<a href="https://www.trinka.ai/jp/features/credits" target="_blank" class="text-link">Trinkaトークンのページ</a>をご覧ください。
                            </p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>


    <div class="faqQuestionAnwser section-pd" #target>
        <div class="trinka_container">
            <div class="row justify-content-center">
                <div class="col-lg-8 col-md-10">
                    <div class="trinka-title text-center">
                        <h2>LaTeXファイル自動校正に関するよくあるご質問</h2>
                        <div class="HeadingSubLine1 justify-content-center"><span></span><span></span><span></span></div>
                    </div>
                </div>
            </div>
            <div class="faqQuestionsList">
                <div class="accordion" id="faq">
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="faqContainer">
                                <div class="card">
                                    <div class="card-header" id="QuestionOne">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionOneContent" aria-expanded="true" aria-controls="QuestionOneContent">
                                            TrinkaのLaTeXファイル自動校正はどのように機能しますか？ </a>
                                    </div>
    
                                    <div id="QuestionOneContent" class="collapse" aria-labelledby="QuestionOne" data-parent="#faq">
                                        <div class="card-body">
                                            <p>Trinkaにログイン後、画面左のメインナビゲーション「Proofread File」からLaTeXファイルをアップロードすると、AIが文書の処理を開始します。数分後に、修正されたLaTeXファイルの他、変更履歴付きのMS Wordファイルが生成され、変更箇所も一目瞭然です。</p>
                                            <p>さらに、修正箇所の数、文法ミスの種類、総合的なライティング品質スコアなども提供されます。</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="card">
                                    <div class="card-header" id="QuestionTwo">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionTwoContent" aria-expanded="true"
                                            aria-controls="QuestionTwoContent">
                                            LaTeXファイルの自動校正機能は、無料で使えますか？ </a>
                                    </div>
    
                                    <div id="QuestionTwoContent" class="collapse" aria-labelledby="QuestionTwo" data-parent="#faq">
                                        <div class="card-body">
                                            <p>はい。Trinkaのベーシックプランにご登録いただくと、毎月4Trinkaトークンが無料で付与されます。1ポイントで、LaTeXファイルの文法チェックを5000単語分無料でご利用いただけます。</p>
                                        </div>
                                    </div>
                                </div>
    
                                <div class="card">
                                    <div class="card-header" id="QuestionThree">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionThreeContent" aria-expanded="true"
                                            aria-controls="QuestionThreeContent">
                                            LaTeXファイルの自動校正には、何ポイント必要ですか？
                                        </a>
                                    </div>
    
                                    <div id="QuestionThreeContent" class="collapse" aria-labelledby="QuestionThree" data-parent="#faq">
                                        <div class="card-body">
                                            <p>5000単語ごとに1Trinkaトークンが必要です。</p>
                                        </div>
                                    </div>
                                </div>
    
    
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="faqContainer">
                                <div class="card">
                                    <div class="card-header" id="QuestionFour">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-target="#QuestionFourContent" aria-expanded="true"
                                            aria-controls="QuestionFourContent">
                                            TrinkaのLaTeXファイル自動校正機能は、Overleafなどのエディタ上で作動しますか？
                                        </a>
                                    </div>
    
                                    <div id="QuestionFourContent" class="collapse" aria-labelledby="QuestionFour" data-parent="#faq">
                                        <div class="card-body">
                                            <p>いいえ。TrinkaはOverleafなど他のツールとは直接統合されていません。Overleafで生成したLaTeXファイルをアップロードしていただけば、Trinka上で自動校正することができます。</p>
                                        </div>
                                    </div>
                                </div>
    
                                <div class="card">
                                    <div class="card-header" id="QuestionFive">
                                        <a href="#" class="btn btn-header-link collapsed" data-toggle="collapse" data-parent="#faq" aria-expanded="true"
                                            aria-controls="QuestionFiveContent">
                                            TrinkaのLaTeXファイル自動校正とLanguageToolなどのLaTeX校正機能との違いは何ですか？
                                        </a>
                                    </div>
    
                                    <div id="QuestionFiveContent" class="collapse" aria-labelledby="QuestionFive" data-parent="#faq">
                                        <div class="card-body">
                                            <p>Trinkaのファイル自動校正では、LaTeXファイルのソースコードを保ちながら言語だけを修正。研究者やテクニカルライターの方に便利にお使いいただけます。</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div class="otherApps section-pd-sm">
        <div class="trinka_container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="trinka-title text-center">
                        <h3 class="text-white">もっとあります
                            Trinkaの
                            使い方</h3>
                    </div>
                    <ul>
                        <li>
                            <a [routerLink]="['/trinkacloud']">
                                <div class="app_name_content">
                                    <div class="app_name_content_overlay"></div>
                                    <img src="assets/images/Other_apps_TrinkaCloud.svg" alt="cloud">
                                    <h3>Cloud</h3>
                                </div>
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="['/wordplugin']">
                                <div class="app_name_content">
                                    <div class="app_name_content_overlay"></div>
                                    <img src="assets/images/Others_App_MSWord.svg" alt="ms word">
                                    <h3><span class="OpenSansFonts" style="font-weight: bold;">MS Word</span>
                                        <br /> プラグイン</h3>
                                </div>
                        </a>
                        </li>
                        <li>
                            <a [routerLink]="['/browser-plugin']">
                                <div class="app_name_content">
                                    <div class="app_name_content_overlay"></div>
                                    <img src="assets/images/other_Apps_browser.svg" alt="browser">
                                    <h3>ブラウザ
                                        <br />プラグイン</h3>
                                </div>
                            </a>
                        </li>
                        <li>
                            <a [routerLink]="['/enterprise']">
                                <div class="app_name_content" style="padding: 0px;">
                                    <div class="app_name_content_overlay"></div>
                                    <img src="assets/images/Other_Apps_enterprise.svg" alt="enterprise">
                                    <h3 style="margin: 0 0 -2px 0;">Enterprise</h3>
                                    <span style="font-size: 12px; color: #000; position: relative;">(API, JS, & On-Premise)</span>
                                </div>
                            </a>
                        </li>
                        
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="wordPluginPopup" tabindex="-1" role="dialog" aria-labelledby="wordPluginLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-body" style="padding: 0;">
                <button type="button" id="closedPopup" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div id="iframeHolder"></div>

                <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/joaE-2djPGE"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe>
                <!-- <iframe class="youtubeVideoForTryDemo" id="iframe" width="100%" height="450" src="https://www.youtube.com/embed/z-TVcRwVp3A"
                    title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen></iframe> -->
            </div>
        </div>
    </div>
</div>